import React from 'react';
import PropTypes from 'prop-types';
import withSelfServeCreator from 'withSelfServeCreator';
import SelfServePopup from './SelfServePopup';

const RECIPIENT_LABEL_DEFAULT = "Recipient's signature will appear here. ";
const RECIPIENT_LABEL_CONTRACTED = "Recipient's signature. ";
const CONTRACTED_LABEL_CUTOFF = 324;
const DEFAULT_SIGNATURE_ICON_WIDTH = 50;
const DEFAULT_SIGNATURE_ICON_HEIGHT = 28;
const NO_LABEL_CUTOFF = 208;
const MINIMUM_WIDTH = 165;
const MINIMUM_HEIGHT = 30;
const SIGNATURE_POPUP_MAXIMUM_HEIGHT = 100;

export class SignaturePopup extends React.PureComponent {
  render() {
    let recipientLabelShown;
    let userData;
    if (this.props.width >= CONTRACTED_LABEL_CUTOFF) {
      recipientLabelShown = RECIPIENT_LABEL_DEFAULT;
    }
    if (this.props.width < CONTRACTED_LABEL_CUTOFF) {
      recipientLabelShown = RECIPIENT_LABEL_CONTRACTED;
    }
    if (this.props.width < NO_LABEL_CUTOFF) {
      recipientLabelShown = '';
    }

    const signatureIconAspectRatio = DEFAULT_SIGNATURE_ICON_WIDTH / DEFAULT_SIGNATURE_ICON_HEIGHT;

    if (this.props.userData) {
      userData = this.props.userData.url;
    }

    return (
      <SelfServePopup
        isActive={this.props.isActive}
        width={this.props.width}
        height={this.props.height}
        isSignature
        isSelected={this.props.isSelected}
        isPreviewMode={this.props.isPreviewMode}
        userData={userData}
        zoomFactor={this.props.zoomFactor}
      >
        <div
          className="request-signature-widget self-serve-popup signature-popup"
          style={{
            height: this.props.height,
            width: this.props.width,
          }}
        >
          <div className="popup-recipient-label-container signature-recipient-label-container">
            <img
              src="/images/self-serve-builder/toolbox/signature-icon-answer-box-2x.png"
              alt="signature icon"
              style={{
                height: this.props.height * 0.5,
                maxHeight: `${DEFAULT_SIGNATURE_ICON_HEIGHT}px`,
                maxWidth: `${DEFAULT_SIGNATURE_ICON_WIDTH}px`,
                width: signatureIconAspectRatio * this.props.height * 0.5,
              }}
            />
            {recipientLabelShown}
          </div>
        </div>
      </SelfServePopup>
    );
  }
}

SignaturePopup.defaultProps = {
  isActive: false,
  isPreviewMode: false,
  isSelected: false,
  userData: null,
  zoomFactor: 1,
};

SignaturePopup.propTypes = {
  height: PropTypes.number.isRequired,
  isActive: PropTypes.bool,
  isPreviewMode: PropTypes.bool,
  isSelected: PropTypes.bool,
  userData: PropTypes.shape({
    type: PropTypes.String,
    url: PropTypes.String,
  }),
  width: PropTypes.number.isRequired,
  zoomFactor: PropTypes.number,
};

const SignaturePopupWithSelfServeCreator = withSelfServeCreator(SignaturePopup, {
  withDragAndResizeProps: {
    resizeProps: {
      minWidth: MINIMUM_WIDTH,
      minHeight: MINIMUM_HEIGHT,
      maxHeight: SIGNATURE_POPUP_MAXIMUM_HEIGHT,
    },
  },
});

export default SignaturePopupWithSelfServeCreator;



// WEBPACK FOOTER //
// ./src-react/Popups/SelfServeBuilderPopups/SignaturePopup.jsx